// @flow
import { createAction } from 'redux-actions';

import type { ActionType } from 'types/redux';
import * as actionTypes from './actionTypes';

export const setOptimizelyABTest = createAction(
  actionTypes.SET_OPTIMIZELY_AB_TEST,
  (optimizelyObject: Object) => optimizelyObject
);

const actions = {
  setOptimizelyABTest
};

export type Action = ActionType<$Values<typeof actions>>;



// WEBPACK FOOTER //
// ./src/store/reducers/optimizelyABTest/actions.js